var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuche(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8777 15.6678L13.0059 11.796C14.0436 10.5949 14.6713 9.03152 14.6713 7.32364C14.6713 3.54574 11.5985 0.476465 7.82413 0.476465C4.04623 0.476465 0.976953 3.54931 0.976953 7.32364C0.976953 11.098 4.04979 14.1708 7.82413 14.1708C9.53201 14.1708 11.0954 13.5431 12.2965 12.5054L16.1683 16.3772C16.2652 16.4741 16.3957 16.5265 16.523 16.5265C16.6498 16.5265 16.7806 16.478 16.8779 16.3771C17.072 16.1828 17.0719 15.862 16.8777 15.6678ZM1.98128 7.32364C1.98128 4.10198 4.60245 1.48434 7.82058 1.48434C11.0422 1.48434 13.6599 4.10551 13.6599 7.32364C13.6599 10.5418 11.0422 13.1665 7.82058 13.1665C4.60247 13.1665 1.98128 10.5453 1.98128 7.32364Z",
    fill: "currentColor",
    stroke: "#69AAC6",
    strokeWidth: 0.05
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuche);
export default __webpack_public_path__ + "static/media/suche.d8d523dc0b9bbb270ea48d56114cb459.svg";
export { ForwardRef as ReactComponent };